import React from "react";
import styled from "styled-components";

import { ModalService } from "../service/modal-service";
import { Col, Text, Button, Row } from "../comps";
import { Theme } from "../theme/theme-provider";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.color.BLACK_0};
  overflow: hidden;
  align-items: center;
`;

const Head = styled(Col)`
  width: 90%;
  height: 40px;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_2};
`;

const ButtonWrapper = styled(Row)`
  margin-top: 15px;
  width: 94%;
  justify-content: space-between;
`;

// buttons:[icon,name,onclick]
export default ({ title, buttons }) => {
  return (
    <Wrapper>
      <Head>
        <Text
          fontSize="20px"
          width="90%"
          color={Theme.textColor.light}
          textAlign="left"
        >
          {title}
        </Text>
      </Head>
      <ButtonWrapper>
        {buttons &&
          buttons.length > 0 &&
          buttons.map(({ icon, name, onClick }) => {
            return (
              <Button
                width="180px"
                buttonTextColor={Theme.textColor.light}
                borderRadius="50"
                buttonBackground={Theme.color.BLUE_4}
                buttonName={name}
                buttonIcon={icon}
                buttonFontSize="14px"
                size="small"
                onClick={() => {
                  onClick();
                }}
              />
            );
          })}
      </ButtonWrapper>
    </Wrapper>
  );
};
